<div>
  <!-- <div class="searcher-panel" [@searcherPanel]="isSearcherPanelOpen ? 'open' : 'closed'" *ngIf="isSearcherPanelOpen">
    <div class="searcher-panel-header">
      
      <div class="searcher-panel-header-text">
        <h3>Buscar en: <span class="title-layer">{{ selectedSearchLayer?.name }}</span></h3>
        <label>(<span class="subtitle-total">{{ searcherTotalResults }}</span>)</label>
      </div>
      
      <img class="close-searcher-button" [src]="'cancelar.svg' | findUrl" (click)="closeLayerSearcher()">
      <mat-icon class="close-searcher-button" (click)="closeLayerSearcher()">close</mat-icon>
    </div>
    <div class="searcher-panel-content">
      <app-location-searcher *ngIf="selectedSearchLayer"
        [layer]="selectedSearchLayer"
        [isSearchDisabled]="!selectedSearchLayer?.checked || searcherTotalResults === 'Cargando...' || searcherTotalResults === '0'"
        (searchTotal)="updateSearchTotal($event)">
      </app-location-searcher>
    </div>
  </div> -->

  <div class="box">
    <div class="drag-handle">
      <button (click)="onClickListaCapas()" class="circle-button">
        <div class="button-icon">
          <img *ngIf="this.layerCatalogService.isInternalLayersVisible" [src]="'icon_capas_internas.svg' | findUrl" class="img-button">
          <img *ngIf="!this.layerCatalogService.isInternalLayersVisible" [src]="'icon_capas_internas_gris.svg' | findUrl" class="img-button">
        </div>
      </button>
    </div>
    <div [@mostrarLista]="this.layerCatalogService.isInternalLayersVisible ? 'visible' : 'hidden'" class="switch-list" [ngClass]="{'overflowHidden': this.panelInternalLayerService.isExpandCollapseAnimating}">
      <div>
        <div *ngIf="isGPSCategoriesVisible || hasNonVirtualCategories" class="tool-title">
          <mat-icon (click)="toggleInternalLayers()" class="expand-icon" [ngClass]="{'expanded': this.panelInternalLayerService.isInternalLayersExpanded}">expand_more</mat-icon>
          <h2>Capas Internas</h2>
            <!-- <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false"  fontIcon="cancel" (click)="ClosePanel()"></mat-icon> -->
        </div>

        <div [@expandCollapseLayers]="this.panelInternalLayerService.isInternalLayersExpanded ? 'expanded' : 'collapsed'" (@expandCollapseLayers.start)="onExpandCollapseStart($event)" (@expandCollapseLayers.done)="onExpandCollapseDone($event)" class="switch-container">
          
          <div class="switch-item" *ngIf="isGPSCategoriesVisible">
            <div class="switch-searcher col-1">
                <!-- <mat-icon *ngIf="capa.checked" class="search-icon" (click)="openLayerSearcher(capa)" matTooltip="Buscar ubicación">arrow_back_ios</mat-icon> -->
                <mat-icon *ngIf="panelInternalLayerService.activeLayer.checked" class="refresh-icon" (click)="onRestartLayerActivos()" matTooltip="Recargar capa">refresh</mat-icon>
              </div>
            <label class="switch" [id]='"layer-locationsGeneral"'>
              <!-- <img *ngIf="this.panelInternalLayerService.activeLayer.checked" [src]="'btn_add_green.svg' | findUrl" class="img-button"> -->
              <img *ngIf="!this.panelInternalLayerService.activeLayer.checked" [src]="'btn_add_grey.svg' | findUrl" class="img-button" (click)="onAddLayerActivos()">
            </label>
            <span class="layer-name">
              <!-- <img [src]="'nodes.png' | findUrl" class="img-layer">  -->
              Activos
            </span>
            <div class="gps-type-buttons" *ngIf="panelInternalLayerService.activeLayer.checked">
              <button
                class="gps-type-btn"
                [class.active]="(panelInternalLayerService.activeLayerGpsTypeSelected | async) === EnumPanelGPSTabTypes.Actualizados"
                (click)="activateGPSLayer(EnumPanelGPSTabTypes.Actualizados)"
                matTooltip="Actualizados">
                <img src="/assets/img/locationPanel/gps_activo.svg">
              </button>
              <button
                class="gps-type-btn"
                [class.active]="(panelInternalLayerService.activeLayerGpsTypeSelected | async) === EnumPanelGPSTabTypes.Desactualizados"
                (click)="activateGPSLayer(EnumPanelGPSTabTypes.Desactualizados)"
                matTooltip="Desactualizados">
                <img src="/assets/img/locationPanel/gps_rojo.svg">
              </button>
              <button
                class="gps-type-btn"
                [class.active]="(panelInternalLayerService.activeLayerGpsTypeSelected | async) === EnumPanelGPSTabTypes.SinReporte"
                (click)="activateGPSLayer(EnumPanelGPSTabTypes.SinReporte)"
                matTooltip="Sin Reporte">
                <img src="/assets/img/locationPanel/gps_tache.svg">
              </button>
              <!-- <button
                class="gps-type-btn"
                [class.active]="(panelInternalLayerService.activeLayerGpsTypeSelected | async) === EnumPanelGPSTabTypes.Todos"
                (click)="activateGPSLayer(EnumPanelGPSTabTypes.Todos)"
                matTooltip="Todos">
                <img src="/assets/img/locationPanel/gps_activo.svg">
              </button> -->
            </div>
            <div class="switch-loading col-2">
              <loading [isLoading]="panelInternalLayerService.activeLayer.isLoading" [isAbsolute]="false"></loading>
            </div>
          </div>

          <div class="switch-item" *ngIf="isGPSCategoriesVisible && this.panelInternalLayerService.isFilterLayer">
            <div class="switch-searcher col-1">
              <!-- <mat-icon *ngIf="capa.checked" class="search-icon" (click)="openLayerSearcher(capa)" matTooltip="Buscar ubicación">arrow_back_ios</mat-icon> -->
              <mat-icon *ngIf="panelInternalLayerService.filterLayer.checked" class="refresh-icon" (click)="onRestartLayerFiltros()" matTooltip="Recargar capa">refresh</mat-icon>
            </div>
            <label class="switch" [id]='"filter-layer-locationsGeneral"'>
              <!-- <img *ngIf="this.panelInternalLayerService.filterLayer.checked" [src]="'btn_add_green.svg' | findUrl" class="img-button"> -->
              <img *ngIf="!this.panelInternalLayerService.filterLayer.checked" [src]="'btn_add_grey.svg' | findUrl" class="img-button">
            </label>
            <span class="layer-name">
              <!-- <img [src]="'nodes.png' | findUrl" class="img-layer">  -->
              Activos Filtrados </span>
            <div class="switch-loading col-2">
              <loading [isLoading]="panelInternalLayerService.filterLayer.isLoading" [isAbsolute]="false"></loading>
            </div>
          </div>

          <ng-container *ngFor="let capa of $capas">
            <div *ngIf="(allowedParts?.allowedCategories?.includes(capa.categoryId?.toString()) && !capa.itWorksAsVirtualLocation) || capa.idLayerType == enumLayerTypes.Geofence" class="switch-item">
              <div class="switch-searcher col-1">
                <!-- <mat-icon *ngIf="capa.checked && selectedSearchLayer !== capa" class="search-icon" (click)="openLayerSearcher(capa)" matTooltip="Buscar ubicación">arrow_back_ios</mat-icon>
                <mat-icon *ngIf="capa.checked && selectedSearchLayer === capa" class="search-icon" (click)="openLayerSearcher(capa)" matTooltip="Buscar ubicación">arrow_forward_ios</mat-icon> -->
                <mat-icon *ngIf="capa.checked" class="refresh-icon" (click)="onRestartLayer(capa)" matTooltip="Recargar capa">refresh</mat-icon>
              </div>
              <label class="switch col-3">
                <!-- <img *ngIf="capa.checked" [src]="'btn_add_green.svg' | findUrl" class="img-button" [id]="capa.name"> -->
                <img *ngIf="!capa.checked" [src]="'btn_add_grey.svg' | findUrl" class="img-button" [id]="capa.name" (click)="addLayer(capa)">
              </label>
              <span class="col-5 layer-name">
                <!-- <img [src]="capa.icon | findUrl" class="img-layer"> -->
                {{ capa.name }}
              </span>
              <!-- <div *ngIf="capa.isFilteredLayer" class="switch-loading col-2">
                <mat-icon *ngIf="capa.hasBeenFiltered">filter_alt_off</mat-icon>
                <img [src]="'filtrar_boton.svg' | findUrl" *ngIf="!capa.hasBeenFiltered">
              </div> -->
              <div class="switch-loading col-2">
                <loading [isLoading]="capa.isLoading" [isAbsolute]="false"></loading>
              </div>
            </div>
          </ng-container>
        </div>

        

        <div *ngIf="hasVirtualCategories" class="tool-title">
          <mat-icon (click)="toggleVirtualLayers()" class="expand-icon" [ngClass]="{'expanded': this.panelInternalLayerService.isVirtualLayersExpanded}">expand_more</mat-icon>
          <h2>Capas Virtuales</h2>
        </div>

        <div  *ngIf="hasVirtualCategories" [@expandCollapseLayers]="this.panelInternalLayerService.isVirtualLayersExpanded ? 'expanded' : 'collapsed'"  (@expandCollapseLayers.start)="onExpandCollapseStart($event)" (@expandCollapseLayers.done)="onExpandCollapseDone($event)" class="switch-container">
          <ng-container *ngFor="let capa of $capas">
            <div *ngIf="allowedParts?.allowedCategories?.includes(capa.categoryId?.toString()) && capa.itWorksAsVirtualLocation" class="switch-item">
              <div class="switch-searcher col-1">
                <!-- <mat-icon *ngIf="capa.checked && selectedSearchLayer !== capa" class="search-icon" (click)="openLayerSearcher(capa)" matTooltip="Buscar ubicación">arrow_back_ios</mat-icon>
                <mat-icon *ngIf="capa.checked && selectedSearchLayer === capa" class="search-icon" (click)="openLayerSearcher(capa)" matTooltip="Buscar ubicación">arrow_forward_ios</mat-icon> -->
                <mat-icon *ngIf="capa.checked" class="refresh-icon" (click)="onRestartLayer(capa)" matTooltip="Recargar capa">refresh</mat-icon>
              </div>
              <label class="switch col-2">
                <!-- <img *ngIf="capa.checked" [src]="'btn_add_green.svg' | findUrl" class="img-button" [id]="capa.name"> -->
                <img *ngIf="!capa.checked" [src]="'btn_add_grey.svg' | findUrl" class="img-button" [id]="capa.name" (click)="addLayer(capa)">
              </label>
              <span class="col-5 layer-name">
                <!-- <img [src]="capa.icon | findUrl" class="img-layer"> -->
                {{ capa.name }}
              </span>
              <div *ngIf="capa.isFilteredLayer" class="switch-loading col-2">
                <!-- <mat-icon *ngIf="capa.hasBeenFiltered" (click)="onClickLayerFilter(capa)">filter_alt_off</mat-icon> -->
                <img [src]="'filtrar_boton.svg' | findUrl" (click)="onClickLayerFilter(capa)">
              </div>
              <div class="switch-loading col-2">
                <loading [isLoading]="capa.isLoading" [isAbsolute]="false"></loading>
              </div>
            </div>
          </ng-container>
        </div>

        <!-- <div *ngFor="let capa of $capas" class="switch-item">
          <label class="switch">
            <img *ngIf="capa.checked" [src]="'btn_add_green.svg' | findUrl" class="img-button" [id]=capa.name (click)="onToggleLayer(capa)">
            <img *ngIf="!capa.checked" [src]="'btn_add_grey.svg' | findUrl" class="img-button" [id]=capa.name (click)="onToggleLayer(capa)">
          </label>
          <span>
            <img [src]="capa.icon | findUrl" class="img-layer"> comentario
            {{ capa.name }}
          </span>
        </div> -->
      </div>

      <!-- <div>
        <app-generated-layers></app-generated-layers>
      </div> -->
      
    </div>
  </div>
</div>